import produce from 'immer';
import { type IReference, ReferenceType } from '../IReference.ts';
import { ReferencePathDirection } from '../IReferencePath.ts';

/**
 * Normalizza una reference virtuale, aggiungendo il prefisso fornito.
 * Ci sono due casi:
 * 1. Se la reference non ha nel `path` degli elementi "Child", vuol dire
 *   che è una reference che punta ad un widget padre, e quindi va aggiunto
 *   al `code` direttamente il prefisso
 *
 * 2. Se la reference ha nel `path` degli elementi "Child", vuol dire che
 *    Il suo `code` è corretto, ma bisogna aggiungere il prefisso al _primo_
 *    elemento `Child` del `path` (es. `widget@options.opzione1` deve diventare
 *   `tabella1_r1_widget@options.opzione1`)
 */
// TODO Calcolare l'ID corretto della nuova reference, probabilmente ci serve che siano passati i parametri (es. id tabella) o una funzione (es. x la table che chiami al suo interno `engineCellWidgetId`)
export function normalizeVirtualReference(
  reference: IReference,
  prefix: string,
) {
  if (reference.type !== ReferenceType.VirtualColumn) {
    if (process.env.NODE_ENV !== 'production') {
      // biome-ignore format: <tbd>
      console.warn(`[normalizeVirtualReference] Unsupported reference type`, {reference});
    }
    return reference;
  }

  const firstChildPathItemIndex = reference.path.findIndex(
    p => p.direction === ReferencePathDirection.Child,
  );

  // Caso 1. Non ci sono elementi "Child" nel path, quindi aggiungiamo il
  // prefisso direttamente al `code`
  if (firstChildPathItemIndex === -1) {
    return {
      ...reference,
      // virtualTypeValue: getVirtualTypeValue(reference, virtualValues),
      type: ReferenceType.Widget,
      code: `${prefix}_${reference.code}`,
    } as IReference;
  }

  // Caso 2. Aggiungiamo il prefisso al primo elemento "Child" del path
  return produce(reference, draft => {
    draft.type = ReferenceType.Widget;
    // if (virtualValues) {
    //   draft.virtualTypeValue = getVirtualTypeValue(reference, virtualValues);
    // }
    draft.path[firstChildPathItemIndex].code =
      `${prefix}_${draft.path[firstChildPathItemIndex].code}`;
  });
}

/**
 * @deprecated Le reference virtuali devono essere inserite nello Schema
 * di validazione
 */
function getVirtualTypeValue(
  ref: IReference,
  virtualValues?: Record<string, any>,
) {
  if (!virtualValues) return undefined;
  if (ref.virtualType && virtualValues[ref.virtualType]) {
    return virtualValues[ref.virtualType];
  }
}
